import GenericAreaPage from "@/components/GenericAreaPage";
import { getAreaContent } from "@/lib/area-content";

const TheWoodlands = () => {
  const content = getAreaContent("the-woodlands");
  if (!content) return null;
  return <GenericAreaPage content={content} />;
};

export default TheWoodlands;